import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

export default {

    async atualizarDataDeEntregaContratual(jobValores = {}){

        let job;

        try{

            const payload = {
                id: jobValores?.id || "",
                dateFinalEfetiva: jobValores?.dateFinalEfetiva || null,
            };

            job = await ERP.patchOne(Schema.JOB, payload);
            if(job.status != 200){
                throw job;
            }

            console.log(job);

        }catch(e){

            console.log(e);
            return job;

        }

        return job;

    },

}
